<template>
    <div class="container-not-found">
        <img
            class="plug-left"
            src="../../assets/images/plug-short-left.svg"
            alt=""
        />
        <h1 class="title-disconnect">Usuario desconectado</h1>
        <div class="title">
            <h1>Vuelve a Iniciar sesión</h1>
        </div>
        <img
            class="plug-right"
            src="../../assets/images/plug-short-right.svg"
            alt=""
        />
        <img class="logo-roma" src="../../assets/images/logo-roma.svg" alt="" />
    </div>
</template>

<script>
export default {
    name: "Disconnect"
};
</script>

<style lang="scss" scoped>
.container-not-found {
    overflow: hidden !important;
    background-image: url("../../assets/images/bg-404.svg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center top;
    width: 100%;
    height: 100%;
    .title-disconnect {
        color: #E97C21;
        text-align: center;
        font-size: 50px;
        margin-top: 35vh;
    }

    .bg-404 {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
    }
    .plug-left {
        width: 30%;
        position: absolute;
        top: 28%;
        left: 0;
        overflow: hidden !important;
    }

    .plug-right {
        width: 30%;
        position: absolute;
        top: 26%;
        right: 0;
        float: right;
        overflow: hidden !important;
    }

    ._404 {
        position: absolute;
        top: 25%;
        left: 40%;
        width: 20%;
    }

    .title {
        position: absolute;
        top: 55vh;
        left: 0;
        width: 100%;
        text-align: center;
        h1 {
            font-size: 1.625em;
            font-family: cabin, Regular, serif;
        }
    }
    .logo-roma {
        position: absolute;
        bottom: 8%;
        left: 44%;
        width: 10%;
    }
}

@media (max-width: 800px) {
    .container-not-found {
        overflow: hidden !important;
        background-image: url("../../assets/images/bg-404-mobile.svg");
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center top;
        width: 100%;
        height: 100%;
        .bg-404 {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
        }
        .plug-left {
            width: 35%;
            position: absolute;
            top: 35%;
            left: 0;
        }

        .plug-right {
            position: absolute;
            top: 34%;
            right: 0;
            width: 35%;
        }

        ._404 {
            position: absolute;
            top: 35%;
            left: 40.5%;
            width: 20%;
        }

        .title {
            position: absolute;
            top: 53%;
            left: 0;
            width: 100%;
            text-align: center;
            h1 {
                font-size: 12px;
                font-family: cabin, Regular, serif;
            }
        }
        .logo-roma {
            position: absolute;
            bottom: 15%;
            left: 40%;
            width: 25%;
        }
        .title-disconnect {
            color: #e97c21;
            text-align: center;
            font-size: 30px;
            margin-top: 43vh;
        }
    }
}
</style>
